import { Address as AddressViem } from 'viem';

import {
  AvailableChainIdType,
  ZERO_ADDRESS,
} from '@constants/common/chain.constants';
import { NATIVE_TOKEN, TOKENS } from '@constants/common/tokens.constants';

import { Token } from '@app-types/common/token.types';

type Address = string | AddressViem | undefined | null;

export function isAddressesEqual(
  address0: Address,
  address1: Address,
): boolean {
  if (!address0 || !address1) return false;
  return address0.toLowerCase() === address1.toLowerCase();
}

export function findTokenByAddress(
  address: string,
  chainId: AvailableChainIdType,
): Token | undefined {
  if (isAddressesEqual(address, ZERO_ADDRESS)) return NATIVE_TOKEN[chainId];
  return Object.values(TOKENS[chainId]).find((token) =>
    isAddressesEqual(token.address, address),
  );
}
